define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		toWriter: function() {
			var	call = this.inherited(arguments);
			if (!call) {
				this._toCallWriter();
			}

			return call;
		},

		_toCallWriter: function() {
			this.m_writer.freezeNode(this.m_urlNode, !this.m_bToggle);
		},

		postProcessSuccess: function() {
			// summary: refresh display of node unless configured PostAction returns deferred object in which
			// case that should do all refreshing
			var	dfd = this.inherited(arguments);
			return dfd ? dfd : this.widget.redrawNode(this.m_element);
		}
	});
});